import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Menu, MenuContent, MenuTrigger } from './Menu';
import { SquareButton } from './Button';
import Icon from './Icon';

const Opener = styled(SquareButton)`
  ${({ small }) =>
    small &&
    `
    width: 32px;
    height: 24px;
  `}

  &[aria-expanded="true"] {
    border: 1px solid var(--primary);
    background-color: var(--luna);

    ${Icon} {
      color: var(--primary);
    }
  }
`;

/**
 * NOTE: We must spread props to trigger component when using asChild:
 *       https://github.com/radix-ui/primitives/issues/725
 */
const OpenButton = forwardRef(
  ({ icon, small, ...unhandledProps }, forwardedRef) => (
    <Opener
      aria-label="Open more menu"
      icon={icon}
      ref={forwardedRef}
      kind="secondary"
      small={small}
      {...unhandledProps}
    />
  )
);

OpenButton.propTypes = {
  icon: PropTypes.string,
  small: PropTypes.bool,
};

const MoreMenu = ({
  icon = 'ellipsis-h',
  align = 'end',
  children,
  side = 'bottom',
  small = false,
}) => (
  <Menu>
    <MenuTrigger asChild>
      <OpenButton icon={icon} small={small} />
    </MenuTrigger>
    <MenuContent align={align} side={side} sideOffset={12}>
      {children}
    </MenuContent>
  </Menu>
);

MoreMenu.propTypes = {
  align: PropTypes.oneOf(['start', 'center', 'end']),
  children: PropTypes.node,
  icon: PropTypes.string,
  side: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  small: PropTypes.bool,
};

export default styled(MoreMenu)``;
